import MasterRoutes from './MasterRoutes';
import DashRoutes from './DashRoutes';
import NotificationRoutes from './NotificationRoutes';
import AntiCoiRoutes from './AntiCoiRoutes';
import AssessmentRoutes from './AssessmentRoutes';
import NkoRoutes from './NkoRoutes';

const routes = [
  ...MasterRoutes,
  ...DashRoutes,
  ...NotificationRoutes,
  ...AntiCoiRoutes,
  ...AssessmentRoutes,
  ...NkoRoutes,
];

export default routes;
